import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import MarketingLayout from './MarketingLayout'
import Seo from './Seo'
import StoreBadges from './StoreBadges'
import FEATURES from './featuresData'
import '../AppLandingPage.css'
import './Marketing.css'

/** /features — index of every feature with links to the detail pages. */
export default function FeaturesIndex() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <MarketingLayout>
            <Seo
                title="Wedding Planning App Features | First Dance"
                description="Everything you need to plan your wedding: guest list, digital RSVPs, wedding website, table planner, menu planner, day schedule, checklist, save the dates and guest photo album."
                path="/features"
            />

            <div className="marketing-page">
                <div className="marketing-hero">
                    <p className="marketing-breadcrumb">
                        <Link to="/">Home</Link> &rsaquo; Features
                    </p>
                    <h1>Everything you need to plan your wedding</h1>
                    <p className="marketing-hero-motto">The fun way to plan your wedding day</p>
                    <p className="marketing-hero-intro">
                        First Dance brings your guest list, RSVPs, wedding website, seating plan, menu,
                        schedule and checklist together in one playful app made for UK couples. Explore each
                        feature below.
                    </p>
                </div>
                <div className="hero-divider" />

                <section className="marketing-section">
                    <div className="marketing-container">
                        <div className="features-index-grid">
                            {FEATURES.map((feature) => (
                                <Link
                                    key={feature.slug}
                                    to={`/features/${feature.slug}`}
                                    className="feature-index-card"
                                >
                                    <img
                                        src={feature.image}
                                        alt={feature.imageAlt}
                                        className={
                                            feature.imageStyle === 'icon'
                                                ? 'feature-index-card-image icon-style'
                                                : 'feature-index-card-image'
                                        }
                                    />
                                    <div className="feature-index-card-body">
                                        <span
                                            className={`feature-index-plan ${feature.plan === 'Free' ? 'free' : 'premium'}`}
                                        >
                                            {feature.plan === 'Free' ? 'Free' : 'Premium'}
                                        </span>
                                        <h3>{feature.name}</h3>
                                        <p>{feature.tagline}</p>
                                        <span className="feature-index-card-cta">
                                            Learn more about {feature.name.toLowerCase()}
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>

                <div className="marketing-cta-band">
                    <h2>Ready to start planning?</h2>
                    <p>Download First Dance free and take the first step today</p>
                    <StoreBadges />
                </div>
            </div>
        </MarketingLayout>
    )
}
